// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { FachbereichEntity } from '../../../entities/mdqx/fachbereich.entity';

export enum FachbereichActionTypes {
    GetRequest = '[Fachbereiche] Get Request',
    GetResponse = '[Fachbereiche] Get Response',
}

export class GetFachbereicheRequest implements Action {
    readonly type = FachbereichActionTypes.GetRequest;
}

export class GetFachbereicheResponse implements Action {
    readonly type = FachbereichActionTypes.GetResponse;
    constructor(public Payload: FachbereichEntity[]) {}
}

export type FachbereichActions = GetFachbereicheRequest | GetFachbereicheResponse;
